var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import GlobalVue from "../../globalVue";
import Header from './Header.vue';
import Table from './table.vue';
import OrderService from '../../api/OrderService';
import { Loading } from 'element-ui';
import _ from 'lodash';
import { EPurOrderStatus } from "../../enum/EStatus";
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { EPurOrderErrorCode } from "../../enum/EPurchaseOrderCode";
import TableList from "./component/TableListConfig.vue";
import ArticleList from "../../components/alert/ArticleList.vue";
import Add from './Add';
import DeliverAdd from '../deliver/Add.vue';
import EntrustDeliverAdd from '../entrustedDelivery/Add.vue';
import EHandleStatus from '../../enum/EHandleStatus';
import Purchase from '../purchase/List.vue';
import BindGoods from '../client/BindGoods.vue';
import { handleException } from "../../common/ErrorCodeHandle";
var PurOrderList = (function (_super) {
    __extends(PurOrderList, _super);
    function PurOrderList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = OrderService.getInstance();
        _this.fetchAction = _this.service.getOrderList;
        _this.status = EPurOrderStatus.Bconfirm.toString();
        _this.prevStatus = EPurOrderStatus.Bconfirm.toString();
        _this.listData = [];
        _this.ediBusinessStatus = [];
        _this.total = 0;
        _this.searchParams = null;
        _this.selectRows = [];
        _this.purOrderStatus = EPurOrderStatus;
        _this.fromPage = "list";
        _this.filter = {};
        _this.tableHeight = document.documentElement.clientHeight - 270;
        _this.sortColumns = [
            'order_arriveddate',
            'item_num',
            'order_money',
            'order_ctime',
            'order_confirmdate',
            'delivery_date',
            'order_canceldate',
            'from_system_name',
            'organ_name',
            'customer',
            'shop_name',
            'depot_name'
        ];
        _this.templateType = 18;
        return _this;
    }
    PurOrderList.prototype.created = function () {
        if (this.global_status$$) {
            this.status = this.global_status$$.toString();
            this.prevStatus = this.status;
        }
        ;
    };
    PurOrderList.prototype.mounted = function () {
    };
    PurOrderList.prototype.getOrderList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        this.$refs.cusHeader.moreSearchComHide();
        var params = {
            order_sup_status: this.status,
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            is_sorting: ''
        };
        Object.assign(params, pager, this.searchParams);
        if (this.status != this.purOrderStatus.SumAndSplit.toString()) {
            delete params.is_sorting;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getOrderList(params).then(function (res) {
            var data = res.data.data;
            _.forEach(data, function (item) {
                item.listGoods = [];
                (item.items || []).push({ isBtn: true });
            });
            _this.listData = data;
            _this.total = res.data.total;
            _this.filterEdiStatus();
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderList.prototype.getEdiBusinessList = function () {
        var _this = this;
        this.service.getEdiBusinessList().then(function (res) {
            var data = res.data.data;
            _this.ediBusinessStatus = data;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderList.prototype.filterEdiStatus = function () {
        var _this = this;
        _.forEach(this.listData, function (order) {
            order.edi_business_status = false;
            _.forEach(_this.ediBusinessStatus, function (business) {
                if (order.business_id == business.business_id)
                    order.edi_business_status = business.edi_business_status;
            });
        });
    };
    PurOrderList.prototype.statusChange = function (tab) {
        if (this.prevStatus == tab.name) {
            return;
        }
        ;
        this.status = tab.name;
        this.prevStatus = tab.name;
        switch (tab.name) {
            case '1':
                this.templateType = 18;
                break;
            case '2':
                if (this.openedCodeData.isOpenSorting) {
                    this.templateType = 23;
                }
                else {
                    this.templateType = 19;
                }
                break;
            case '3':
                this.templateType = 20;
                break;
            case '4':
                this.templateType = 21;
                break;
            case '5':
                this.templateType = 22;
                break;
            case '6':
                this.templateType = 26;
                break;
        }
        this.search(this.searchParams);
    };
    PurOrderList.prototype.updated = function () {
    };
    PurOrderList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PurOrderList.prototype.search = function (searchParams) {
        var _this = this;
        this.searchParams = searchParams || this.searchParams;
        typeof (this.searchParams.s_time) == "object" && this.searchParams.s_time && (this.searchParams.s_time = this.searchParams.s_time.format("yyyy-MM-dd hh:mm:ss"));
        typeof (this.searchParams.e_time) == "object" && this.searchParams.e_time && (this.searchParams.e_time = this.searchParams.e_time.format("yyyy-MM-dd hh:mm:ss"));
        this.filter = {
            order_sup_status: this.status,
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined,
            is_sorting: ''
        };
        this.$nextTick(function () {
            Object.assign(_this.filter, _this.searchParams);
            _this.selectRows = [];
            _this.$refs.TableList.fetch();
        });
    };
    PurOrderList.prototype.lookDetail = function (row) {
        var _this = this;
        GlobalVue.$on("purorder-list-refresh", function () {
            _this.$refs.pagination.clear();
        });
        toDetail(EBillType.PurOrder, row.order_id, this);
    };
    PurOrderList.prototype.confirm = function (row) {
        var _this = this;
        var selectRows = row ? [row] : this.selectRows;
        if (!selectRows || !selectRows.length) {
            this.$message.error("请选择单据");
            return;
        }
        this.$confirm("是否要确认?", "提示", {}).then(function (res) {
            var params = {
                order_id: selectRows.map(function (item) { return item.order_id; }).join(",")
            };
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.confirmMul(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 0) {
                    _this.$message.success(res.data.msg || "修改成功");
                    _this.$refs.cusHeader.search();
                    return;
                }
                else if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.$refs.cusHeader.search();
                    return;
                }
                if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                    handleException(_this, res.data, selectRows[0]);
                    return;
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
                _this.$refs.cusHeader.search();
            });
        });
    };
    PurOrderList.prototype.setParamsToSearch = function (params) {
        this.$refs.cusHeader.setParamsToSearch(params);
    };
    PurOrderList.prototype.addTab = function (options) {
        options.opener = this;
        options.showExist = true,
            GlobalVue.$emit('addTab', options);
    };
    PurOrderList.prototype.toShip = function (row) {
        var _this = this;
        console.log('LOG toShip', row);
        var params = {
            order_id: row.order_id,
            delivery_order_id: row.delivery_order_id,
            is_delivery: 1
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getDeliveryGoodList(params)
            .then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                var shipData = res.data.data;
                var _a = row.logistics_type == 5 ? [EntrustDeliverAdd, '修改委托送货单'] : [DeliverAdd, '修改送货单'], componentInstance = _a[0], title = _a[1];
                _this.addTab({
                    component: componentInstance,
                    title: title,
                    name: title + shipData.order_id,
                    cprops: {
                        handleStatus: EHandleStatus.Edit,
                        order_id: shipData.order_id,
                        shipData: shipData
                    }
                });
                return;
            }
            var instance = _this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                },
            }, {
                title: '提示',
                width: 450,
                height: 350,
                closeBtn: false,
            }).instance;
            instance.$on('addClient:ok', function (data) {
                if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                    var good_code = void 0;
                    var business_id = row.business_id.toString();
                    var supplier_to_business_id = row.supplier_to_business_id.toString();
                    GlobalVue.$emit("addTab", {
                        component: BindGoods,
                        title: '绑定货品',
                        showExist: true,
                        name: 'bindGoods_' + supplier_to_business_id,
                        cprops: {
                            clientIds: business_id,
                            business_id: business_id,
                            supplier_to_business_id: supplier_to_business_id,
                            supplierToBusinessIds: supplier_to_business_id,
                            good_code: good_code
                        }
                    });
                }
                if (res.data.code == EPurOrderErrorCode.GOODS_STOCK_IS_SHORT) {
                    _this.addTab({
                        component: Purchase,
                        title: '采购入库',
                        name: '采购入库'
                    });
                }
            });
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderList.prototype.modify = function (row) {
        GlobalVue.$emit("addTab", {
            component: Add,
            title: '编辑订货单',
            opener: this,
            showExist: true,
            name: 'purchaseorder_modify' + row.order_id,
            cprops: {
                orderid: row.order_id,
                Root_PageAuth: this.Root_PageAuth
            }
        });
    };
    PurOrderList.prototype.copyData = function (row) {
        GlobalVue.$emit("addTab", {
            component: Add,
            title: '复制订货单',
            opener: this,
            showExist: true,
            name: 'purchaseorder_copy' + row.order_id,
            cprops: {
                targetOrderId: row.order_id,
                pageUse: 'copy',
                Root_PageAuth: this.Root_PageAuth
            }
        });
    };
    PurOrderList.prototype.discard = function () {
        this.search(this.searchParams);
    };
    PurOrderList = __decorate([
        Component({
            components: {
                'cusHeader': Header,
                'listData': Table,
                TableList: TableList,
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus'
            }))
        })
    ], PurOrderList);
    return PurOrderList;
}(Vue));
export default PurOrderList;
